import forEach from 'lodash/forEach';
import Animate from '../utils/animate';

export default class NewsFilters {
    constructor({el}) {
        this.el = el;
        this.articles = this.el.querySelectorAll('article');
        
        this.bind();

        this.setHeights();
    }

    setHeights() {
        forEach(this.articles, article => {
            article.setAttribute('data-height', article.clientHeight + 50);
        });
    }

    setActiveFilter(el) {
        const filters = this.el.querySelectorAll('#project-filters li');

        forEach(filters, li => {
            li.classList.remove('current-tax');
        });

        el.classList.add('current-tax');
    }

    filterArticles(filterEl) {
        const filter = filterEl.getAttribute('data-filter-slug');
        
        forEach(this.articles, article => {
            if (article.classList.contains(`${filter}`) || filter === 'all') {
                if (article.clientHeight === 0) {
                    const diff = parseInt(article.getAttribute('data-height'), 10);
    
                    Animate(0, diff, {
                        duration: 500,
                        fn: 'easeOutQuad',
                        onStep: val => {
                            article.style.height = `${val}px`;
                        },
                        onFinish: () => {
                            article.style.height = `${diff}px`;
                        }
                    });
                }
            } else {
                if (article.clientHeight !== 0) {
                    const diff = parseInt(article.getAttribute('data-height'), 10);
    
                    Animate(diff, -diff, {
                        duration: 250,
                        fn: 'easeOutQuad',
                        onStep: val => {
                            article.style.height = `${val}px`;
                        },
                        onFinish: () => {
                            article.style.height = `0px`;
                        }
                    });
                }
            }
        });
    }

    bind() {
        this.el.addEventListener('click', evt => {
            const target = evt.target;

            if (target.matches('#project-filters a')) {
                this.filterArticles(target);
                this.setActiveFilter(target.parentNode);
                evt.preventDefault();
            }
        });
    }
}
